<template>
<div>
  <div class="title-bar title-h3" v-if="columnName === null">{{ objtypeName }}</div>
  <el-table-wrapper v-loading="loading" ref="sortedTable" :data="tableData" :columns="columns" :column-default="columnDefault" :show-search-tool="false" :show-overflow-tooltip="true" :pagination="false" @header-click="onClickHeader">
    <template slot-scope="scope" slot="name-slot">
      <span class="link c-pointer" @click="selectApmTree(scope.row)">{{ scope.row.idText }}</span>
    </template>
  </el-table-wrapper>
</div>
</template>
<script>
import { isEmpty } from '@/utils/basic';
import { columnDefault } from '@/constants/table';
import SummaryMixin from '@/mixins/apm/summary';
import ApmAPI from '@/api/apm/common';

export default {
  name: 'WServiceErrorTable',
  mixins: [SummaryMixin],
  data() {
    return {
      columnDefault,
      defaultChartColumn: 'count',
      headerAlign: 'left',
      loading: false,
      tableData: [],
      columns: [
        { prop: 'typeCount', label: '종류 (건)', sortable: true, formatter: this.convertThousandSeparatorFormat },
        { prop: 'count', label: '예외 (건)', sortable: true, formatter: this.convertThousandSeparatorFormat },
      ],
    };
  },
  methods: {
    /**
     * 트랜잭션 예외 목록을 조회한다.
     * @return {[type]} [description]
     * @author jda
     */
    loadData() {
      if (!this.active || isEmpty(this.requestParams)) {
        return;
      }
      this.loading = true;
      ApmAPI.getServiceErrorList(this.requestParams).then((response) => {
        this.loading = false;
        if (response.data.success) {
          this.tableData = response.data.data;
          this.initLoadChart();
        } else {
          this.tableData = [];
        }
      });
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/apm/components/table/ServiceErrorTable.vue